<template>
  <div class="d-none"></div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useCookieWowStore } from '@/stores/cookieWow';

const cookieWowStore = useCookieWowStore();

// Run on the initial visit instead of reinjecting scripts on every page:finish.
onMounted(async () => {
  await cookieWowStore.fetchCookieWowId();

  if (cookieWowStore.cookieWowId && cookieWowStore.gtm) {
    await cookieWowStore.injectCookieWowScript(
      cookieWowStore.cookieWowId,
      cookieWowStore.gtm,
    );
  }
});
</script>
